import {ReportName} from '../constants';
import {ReportTracker, UserTrackingData} from '../report-tracker';
import {commonTrackingEventPropertyName} from '../tracking-setup';
import {getProjectId} from '../util';
import {userCookieUtils} from '../util/user-identity-from-cookie';

export enum ReportTrackingEvent {
  Save = `[ReportManager] Core Report Save`,
  Delete = `[ReportManager] Delete Core Report`,
  Query = `[ReportManager] Core Report Query`,
  Export = `[ReportManager] Core Report Export`,
  OdaSubmitted = `[ReportManager] ODA request submitted`,

  UpdateCustomization = `[ReportManager] Customization Update`,
}

export function getReportTracker({
  appName,
  productionEvents,
  productionPrefix,
  appPersistentProperties,
}: {
  appName: ReportName;
  productionEvents?: Set<string>;
  productionPrefix?: string;
  appPersistentProperties?: () => any;
}) {
  const userIdentity = userCookieUtils.getUserIdentityFromCookie();

  const userTrackingData: UserTrackingData = {
    projectId: parseInt(getProjectId()),
    userName: userIdentity?.name ?? ``,
    userId: userIdentity?.id ?? -1,
    userEmail: userIdentity?.email ?? ``,
  };

  return new ReportTracker({
    userTrackingData,
    productionEvents,
    productionPrefix,
    appPersistentProperties: () => {
      return {
        ...(appPersistentProperties?.() ?? null),
        [commonTrackingEventPropertyName.reportName]: appName,
      };
    },
  });
}
